/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Grid2, Alert, Link, Typography } from '@mui/material';
import { ExpenseModeEnum } from './ExpenseMode.enum';
import { COLORS } from '../../../utils/Application_Constants';

const styles = {
    link: {
        textDecoration: 'underline',
        color: COLORS.LT_JOURNEY,
        cursor: 'pointer',
    },
    alert: {
        marginBottom: '16px',
    },
    text: {
        whiteSpace: 'normal',
        overflow: 'visible',
    },
};

const CustomAlert = ({ severity, children }) => (
    <Grid2>
        <Alert severity={severity} style={styles.alert}>
            <Typography variant="body2" style={styles.text} noWrap>
                {children}
            </Typography>
        </Alert>
    </Grid2>
);

const ExpenseCorrectionAlert = (props) => {
    const { expense, mode } = props;
    const expenseClassLink = {
        [ExpenseModeEnum.CreditCard]: `expenses/credit-card`,
        [ExpenseModeEnum.ClinicianReimbursement]: `expenses/clinician-reimbursement`,
        [ExpenseModeEnum.Payment]: `expenses/payment-request`,
        [ExpenseModeEnum.Vault]: `expenses/vault`,
    };
    const hasPreviousVersion = Boolean(expense?.previousVersionID);
    const hasNewerVersion = Boolean(expense?.newerVersionID);
    const baseLink = `${window.location.origin}/#/${expenseClassLink[mode]}/`;
    const previousVersionLink = hasPreviousVersion
        ? `${baseLink}${expense.previousVersionID}`
        : null;
    const newerVersionLink = hasNewerVersion ? `${baseLink}${expense.newerVersionID}` : null;

    const onClick = (e, link) => {
        e.preventDefault();
        window.open(link, '_blank');
    };

    if (!hasNewerVersion && !hasPreviousVersion) return null;

    if (hasNewerVersion && !hasPreviousVersion) {
        return (
            <CustomAlert severity="warning">
                You are viewing an outdated version of this expense. Some functionalities may be
                disabled. To see a newer version,{' '}
                <Link
                    href={newerVersionLink}
                    onClick={(e) => onClick(e, newerVersionLink)}
                    style={styles.link}
                    target="_blank"
                >
                    click here
                </Link>
                .
            </CustomAlert>
        );
    }

    if (hasPreviousVersion && hasNewerVersion) {
        return (
            <CustomAlert severity="warning">
                You are viewing an outdated version of this expense. Some functionalities may be
                disabled. View a{' '}
                <Link
                    href={newerVersionLink}
                    onClick={(e) => onClick(e, newerVersionLink)}
                    style={styles.link}
                    target="_blank"
                >
                    newer version
                </Link>{' '}
                or the{' '}
                <Link
                    href={previousVersionLink}
                    onClick={(e) => onClick(e, previousVersionLink)}
                    style={styles.link}
                    target="_blank"
                >
                    older version
                </Link>
                .
            </CustomAlert>
        );
    }

    return (
        <CustomAlert severity="info">
            You are viewing a newer version of this expense. To see the older version,{' '}
            <Link
                href={previousVersionLink}
                onClick={(e) => onClick(e, previousVersionLink)}
                style={styles.link}
                target="_blank"
            >
                click here
            </Link>
            .
        </CustomAlert>
    );
};

export default ExpenseCorrectionAlert;
